global.conmed = global.conmed || {};

conmed.videoBlock = function ($) {
    'use strict';
    var that = {

    };

    that.init = function () {
        var components = $('.slider-for-video-block[data-video-block-id]');
        if (components.length > 0) {
            components.each(function (index) {
                var videoBlockId = $(this).data('video-block-id');
                var dataVideoBlockId = '[data-video-block-id="' + videoBlockId + '"]';

                //console.log(dataVideoBlockId);

                $('.slider-for-video-block' + dataVideoBlockId).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '.slider-nav-video-block' + dataVideoBlockId
                });

                $('.slider-nav-video-block' + dataVideoBlockId).slick({
                    vertical: true,
                    verticalSwiping: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    asNavFor: '.slider-for-video-block' + dataVideoBlockId,
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true,
                    arrows: true,
                    responsive: [
                        {
                            breakpoint: 990,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                vertical: true,
                                verticalSwiping: true,
                                arrows: true,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                vertical: false,
                                verticalSwiping: false,
                                arrows: true,
                            }
                        }
                    ]
                });

                $('div' + dataVideoBlockId + ' .brightcove-video').on('click', function () {
                    var playerId = $('.video-div' + dataVideoBlockId + ' .slider-for-video-block').find('.slick-active .brightcove-video video-js video').attr('id');
                    var video = videojs.getPlayer(playerId);

                    //if (video.paused() == true) {
                    //    $('.video-div' + dataVideoBlockId + ' .slider-for-video-block').find(".slick-active .brightcove-video video-js")/*.css("visibility", "hidden")*//*<--hides blue image*/;
                    //    $('.video-btn-div' + dataVideoBlockId).hide();
                    //    $('.slider-nav-video-block' + dataVideoBlockId).removeClass("video-playing");
                    //}
                    //else {
                    //    $('.video-div' + dataVideoBlockId + ' .slider-for-video-block').find(".slick-active .brightcove-video video-js").css("visibility", "visible");
                    //    $('.video-btn-div' + dataVideoBlockId).hide();
                    //    $('.slider-nav-video-block' + dataVideoBlockId).addClass("video-playing");
                    //}
                });

                //Big Icon Play Button
                //$('div' + dataVideoBlockId + ' #play_button').on("click", function () {
                //    var playerId = $('.video-div' + dataVideoBlockId + ' .slider-for-video-block').find(".slick-active .brightcove-video video-js video").attr("id");
                //    var video = videojs.getPlayer(playerId);

                //    $('.video-div' + dataVideoBlockId + ' .slider-for-video-block').find(".slick-active .brightcove-video video-js").css("visibility", "visible");
                //    $('.video-btn-div' + dataVideoBlockId).hide();
                //    video.play();
                //    $('.slider-nav-video-block' + dataVideoBlockId).addClass("video-playing");
                //    //Hides big play button on pause
                //    $('.video-btn-div' + dataVideoBlockId).hide();

                //});

                //Pausing on Slider Scroll
                $(".slider-nav-video-block .brightcove-video, .video-block .slick-arrow").on("click", function () {
                    var videoPlayers = $('.video-div .slider-for-video-block').find(".brightcove-video wistia-player");

                    videoPlayers.each(function () {
                        var playerId = $(this).attr("media-id");
                        //var player = videojs.getPlayer(playerId)
                        var player = document.getElementById(playerId);
                        player.pause();
                    });

                    //$('.video-div .slider-for-video-block').find(".brightcove-video video-js").css("visibility", "hidden");
                    //$('.slider-nav-video-block' + dataVideoBlockId).removeClass("video-playing");
                    //$('.video-btn-div' + dataVideoBlockId).show();
                });

            });
        };


    };

    return that;
}(jQuery);